// extracted by mini-css-extract-plugin
export var loadingSpinner = "_10-0";
export var spinnerContainer = "_10-1";